import { useMemo, useState } from "react";

import { avatarStyle } from "~/common/components/avatar.style";
import { TextIcon } from "~/common/components/text-icon";

interface AvatarProps {
  nameSurname: string;
}

function getName(nameSurname: string): string {
  if (!nameSurname) {
    return "?";
  }
  const name = nameSurname[0];

  return name.charAt(0).toUpperCase();
}

export function Avatar({ nameSurname }: AvatarProps) {
  const name = useMemo(() => getName(nameSurname), [nameSurname]);
  const [imageError, setImageError] = useState(false);

  return !imageError ? (
    <div className={avatarStyle.container()}>
      <img
        src="/api/me/photo"
        alt="user avatar"
        onError={() => setImageError(true)}
      />
    </div>
  ) : (
    <TextIcon text={name} />
  );
}
